export const GET_DICT_VALUES = 'nomination/GET_DICT_VALUES'
export const GET_DICT_VALUES_DONE = 'nomination/GET_DICT_VALUES_DONE'
export const GET_DICT_VALUES_FAIL = 'nomination/GET_DICT_VALUES_FAIL'

export const GET_DICT_NOMINATION = 'nomination/GET_DICT_NOMINATION'
export const GET_DICT_NOMINATION_DONE = 'nomination/GET_DICT_NOMINATION_DONE'
export const GET_DICT_NOMINATION_FAIL = 'nomination/GET_DICT_NOMINATION_FAIL'

export const GET_DICT_PARAMS = 'nomination/GET_DICT_PARAMS'
export const GET_DICT_PARAMS_DONE = 'nomination/GET_DICT_PARAMS_DONE'
export const GET_DICT_PARAMS_FAIL = 'nomination/GET_DICT_PARAMS_FAIL'

export const SET_EMPL_SIGN = 'nomination/SET_EMPL_SIGN'
export const SET_EMPL_SIGN_DONE = 'nomination/SET_EMPL_SIGN_DONE'
export const SET_EMPL_SIGN_FAIL = 'nomination/SET_EMPL_SIGN_FAIL'

export const SET_EMPL_XML = 'nomination/SET_EMPL_XML'
export const SET_EMPL_XML_DONE = 'nomination/SET_EMPL_XML_DONE'
export const SET_EMPL_XML_FAIL = 'nomination/SET_EMPL_XML_FAIL'

export const GET_EMPL_LIST = 'nomination/GET_EMPL_LIST'
export const GET_EMPL_LIST_DONE = 'nomination/GET_EMPL_LIST_DONE'
export const GET_EMPL_LIST_FAIL = 'nomination/GET_EMPL_LIST_FAIL'

export const GET_MIO_CHECK_USER = 'nomination/GET_MIO_CHECK_USER'
export const GET_MIO_CHECK_USER_DONE = 'nomination/GET_MIO_CHECK_USER_DONE'
export const GET_MIO_CHECK_USER_FAIL = 'nomination/GET_MIO_CHECK_USER_FAIL'

export const GET_MIO_BY_ID = 'nomination/GET_MIO_BY_ID'
export const GET_MIO_BY_ID_DONE = 'nomination/GET_MIO_BY_ID_DONE'
export const GET_MIO_BY_ID_FAIL = 'nomination/GET_MIO_BY_ID_FAIL'

export const GET_MIO_LIST = 'nomination/GET_MIO_LIST'
export const GET_MIO_LIST_DONE = 'nomination/GET_MIO_LIST_DONE'
export const GET_MIO_LIST_FAIL = 'nomination/GET_MIO_LIST_FAIL'

export const SET_MIO_ROW = 'nomination/SET_MIO_ROW'
export const SET_MIO_ROW_DONE = 'nomination/SET_MIO_ROW_DONE'
export const SET_MIO_ROW_FAIL = 'nomination/SET_MIO_ROW_FAIL'

export const SET_MIO_XML = 'nomination/SET_MIO_XML'
export const SET_MIO_XML_DONE = 'nomination/SET_MIO_XML_DONE'
export const SET_MIO_XML_FAIL = 'nomination/SET_MIO_XML_FAIL'

export const SET_MIO_SIGN = 'nomination/SET_MIO_SIGN'
export const SET_MIO_SIGN_DONE = 'nomination/SET_MIO_SIGN_DONE'
export const SET_MIO_SIGN_FAIL = 'nomination/SET_MIO_SIGN_FAIL'

export const SET_MIO_REPORT = 'nomination/SET_MIO_REPORT'
export const SET_MIO_REPORT_DONE = 'nomination/SET_MIO_REPORT_DONE'
export const SET_MIO_REPORT_FAIL = 'nomination/SET_MIO_REPORT_FAIL'

export const GET_MIO_REPORT = 'nomination/GET_MIO_REPORT'
export const GET_MIO_REPORT_DONE = 'nomination/GET_MIO_REPORT_DONE'
export const GET_MIO_REPORT_FAIL = 'nomination/GET_MIO_REPORT_FAIL'

export const GET_DTSP_MIO_LIST = 'nomination/GET_DTSP_MIO_LIST'
export const GET_DTSP_MIO_LIST_DONE = 'nomination/GET_DTSP_MIO_LIST_DONE'
export const GET_DTSP_MIO_LIST_FAIL = 'nomination/GET_DTSP_MIO_LIST_FAIL'

export const GET_DTSP_REPORT_LIST = 'nomination/GET_DTSP_REPORT_LIST'
export const GET_DTSP_REPORT_LIST_DONE = 'nomination/GET_DTSP_REPORT_LIST_DONE'
export const GET_DTSP_REPORT_LIST_FAIL = 'nomination/GET_DTSP_REPORT_LIST_FAIL'

export const SET_DTSP_REPORT_SIGN = 'nomination/SET_DTSP_REPORT_SIGN'
export const SET_DTSP_REPORT_SIGN_DONE = 'nomination/SET_DTSP_REPORT_SIGN_DONE'
export const SET_DTSP_REPORT_SIGN_FAIL = 'nomination/SET_DTSP_REPORT_SIGN_FAIL'

export const SET_DTSP_REPORT_XML = 'nomination/SET_DTSP_REPORT_XML'
export const SET_DTSP_REPORT_XML_DONE = 'nomination/SET_DTSP_REPORT_XML_DONE'
export const SET_DTSP_REPORT_XML_FAIL = 'nomination/SET_DTSP_REPORT_XML_FAIL'

export const SET_DTSP_REQS_LIST = 'nomination/SET_DTSP_REQS_LIST'
export const SET_DTSP_REQS_LIST_DONE = 'nomination/SET_DTSP_REQS_LIST_DONE'
export const SET_DTSP_REQS_LIST_FAIL = 'nomination/SET_DTSP_REQS_LIST_FAIL'

export const GET_DTSP_REQS_ONE = 'nomination/GET_DTSP_REQS_ONE'
export const GET_DTSP_REQS_ONE_DONE = 'nomination/GET_DTSP_REQS_ONE_DONE'
export const GET_DTSP_REQS_ONE_FAIL = 'nomination/GET_DTSP_REQS_ONE_FAIL'

export const GET_DTSP_REQS_PAGE = 'nomination/GET_DTSP_REQS_PAGE'
export const GET_DTSP_REQS_PAGE_DONE = 'nomination/GET_DTSP_REQS_PAGE_DONE'
export const GET_DTSP_REQS_PAGE_FAIL = 'nomination/GET_DTSP_REQS_PAGE_FAIL'